// src/components/dashboard/widgets/training-panel.tsx
import { GraduationCap } from 'lucide-react';
import { useAppColors } from '@/src/lib/theme';

interface MemberItem { id: string; name: string }
interface AssignmentItem { user_id: string; completed_at?: string | null; score?: number | null }

interface TrainingPanelProps {
  courseCount: number;
  members: MemberItem[];
  allAssignments: AssignmentItem[];
}

export default function TrainingPanel({ courseCount, members, allAssignments }: TrainingPanelProps) {
  const c = useAppColors();
  return (
    <div className="rounded-2xl border border-cream-line bg-warm-gray p-5 space-y-3 h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-semibold text-cream">
          <GraduationCap size={14} className="text-purple-400" /> Training
        </div>
        <span className="text-xs text-cream-muted">{courseCount} courses</span>
      </div>
      {members.length === 0 ? (
        <p className="text-xs text-cream-muted/50 py-4 text-center">No staff yet</p>
      ) : (
        <div className="space-y-2">
          {members.slice(0, 4).map((m) => {
            const memberAssignments = allAssignments.filter((a) => a.user_id === m.id);
            const completed = memberAssignments.filter((a) => a.completed_at).length;
            const total = memberAssignments.length;
            const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
            return (
              <div key={m.id} className="flex items-center gap-2 py-1 border-b border-cream-line/30 last:border-0">
                <div className="w-6 h-6 rounded-full bg-leaf-500/20 flex items-center justify-center text-[10px] font-bold text-leaf-text flex-shrink-0">
                  {m.name.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-cream truncate">{m.name}</p>
                  <div className="w-full h-1 rounded-full mt-1" style={{ background: c.border }}>
                    <div className={`h-1 rounded-full ${pct >= 70 ? 'bg-leaf-400' : 'bg-amber-400'}`} style={{ width: `${pct}%` }} />
                  </div>
                </div>
                <span className={`text-[10px] font-semibold ${pct >= 70 ? 'text-leaf-text' : 'text-amber-400'}`}>
                  {total > 0 ? `${pct}%` : '—'}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}